import React, { useEffect } from "react";

import { useGetPickupReadinessTime } from "hooks/useGetPickupReadinessTime";

import StorefrontIcon from "components/Icons/storefront.svg";
import { PickupReadinessCardSkeleton } from "components/Shared/Skeletons";

import DefaultPickupLabel from "./DefaultPickupLabel";

type Props = {
  className?: string;
  dispensaryId: number;
  setShownLabel?: React.Dispatch<React.SetStateAction<boolean>>;
};

const PickupReadinessLabel: React.FC<Props> = ({
  dispensaryId,
  setShownLabel,
}) => {
  const { hasPickupLabel, pickupReadinessErrors, pickupReadinessIsLoading } =
    useGetPickupReadinessTime(dispensaryId);

  // * Syncs parent state with what was shown to the user. Primarily used for tracking.
  useEffect(() => {
    if (
      !pickupReadinessIsLoading &&
      !pickupReadinessErrors &&
      hasPickupLabel &&
      setShownLabel
    ) {
      setShownLabel && setShownLabel(true);
    }
  }, [
    pickupReadinessIsLoading,
    pickupReadinessErrors,
    hasPickupLabel,
    setShownLabel,
  ]);

  return pickupReadinessIsLoading ? (
    <div className="flex items-center bg-leafly-white rounded px-xs mt-xs text-xs">
      <div className="flex items-center justify-center">
        <PickupReadinessCardSkeleton />
      </div>
    </div>
  ) : pickupReadinessErrors || !hasPickupLabel ? (
    <DefaultPickupLabel />
  ) : (
    <div className="flex items-center bg-leafly-white rounded px-xs mt-xs text-xs">
      <div className="flex items-center justify-center">
        <StorefrontIcon height="16" width="16" className="mr-xs" />
        <span>Pickup in under 30 mins</span>
      </div>
    </div>
  );
};

export default PickupReadinessLabel;
